import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetAdminList = {
  getAdminList: { data: null, loading: false, error: null },
};

export const getAdminList = createAsyncThunk('user/getAdminList', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/`, {
      params: { type: 'staff', role: 'admin' },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetAdminList = {
  [getAdminList.pending]: (state) => {
    state.getAdminList.loading = true;
    state.getAdminList.error = null;
  },
  [getAdminList.fulfilled]: (state, action) => {
    state.getAdminList.loading = false;
    state.getAdminList.data = action.payload;
    state.getAdminList.error = null;
  },
  [getAdminList.rejected]: (state, action) => {
    state.getAdminList.loading = false;
    state.getAdminList.error = action.payload;
  },
};
